import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

function LoadingState({ label = "Chargement...", className }) {
  return (
    <div className={cn("flex items-center justify-center gap-2 p-6 text-sm text-slate-600", className)}>
      <Loader2 className="h-4 w-4 animate-spin text-emerald-600" />
      <span>{label}</span>
    </div>
  );
}

export { LoadingState };
